var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("dl", { staticClass: "boss-scout-send-wrap cleafix" }, [
        _c("dt", { staticClass: "boss-scout-send-left" }, [
          _vm._v("テンプレート"),
        ]),
        _vm._v(" "),
        _c("dd", { staticClass: "boss-scout-send-right" }, [
          _c(
            "select",
            {
              staticClass: "boss-input-select",
              domProps: { value: _vm.selectedTemplateId },
              on: {
                change: function ($event) {
                  return _vm.setSelectedTemplateMessage(
                    $event.target.value,
                    _vm.selectedTemplateId
                  )
                },
              },
            },
            [
              _c(
                "option",
                {
                  attrs: { "data-test": "template-option-none" },
                  domProps: { value: null },
                },
                [_vm._v("指定なし")]
              ),
              _vm._v(" "),
              _vm._l(_vm.templates, function (template, i) {
                return _c(
                  "option",
                  {
                    key: i,
                    attrs: { "data-test": "template-option-" + i },
                    domProps: { value: template.id },
                  },
                  [_vm._v(_vm._s(template.name) + "\n          ")]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "dd",
          { staticClass: "boss-scout-send-right" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message.subject,
                  expression: "message.subject",
                },
              ],
              staticClass: "boss-send-subject",
              class: {
                "is-invalid-input": _vm.hasTemplateReplacementCharacters(
                  _vm.message.subject
                ),
              },
              attrs: { type: "text", "data-test": "message-subject" },
              domProps: { value: _vm.message.subject },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.message, "subject", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasTemplateReplacementCharacters(_vm.message.subject)
              ? _c("validation-label", {
                  attrs: {
                    "data-test": "has-template-replacement-characters-subject",
                    label:
                      "「●●【」または「】●●」が入力フォームに残っていると、送信することができません",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "dd",
          { staticClass: "boss-scout-send-right" },
          [
            _c("div", { staticClass: "boss-textarea-button" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。",
                      },
                      expression:
                        "{ content: '本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。'}",
                    },
                  ],
                  staticClass: "boss-button",
                  attrs: { "data-test": "user-name" },
                  on: {
                    click: function ($event) {
                      return _vm.insertionValue("■USER_NAME■ 様")
                    },
                  },
                },
                [_vm._v("応募者名を挿入")]
              ),
              _c("span", { staticStyle: { "font-size": ".8125rem" } }, [
                _vm._v("（本文にのみ有効）"),
              ]),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message.body,
                  expression: "message.body",
                },
              ],
              ref: "message",
              staticClass: "boss-send-textarea",
              class: {
                "is-invalid-input": _vm.hasTemplateReplacementCharacters(
                  _vm.message.body
                ),
              },
              attrs: { "data-test": "message-body", rows: "", cols: "" },
              domProps: { value: _vm.message.body },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.message, "body", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.hasTemplateReplacementCharacters(_vm.message.body)
              ? _c("validation-label", {
                  attrs: {
                    "data-test": "has-template-replacement-characters-body",
                    label:
                      "「●●【」または「】●●」が入力フォームに残っていると、送信することができません",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("div", { staticClass: "boss-table-wrap" }, [
        _c("div", { staticClass: "boss-table-2" }, [
          _c(
            "div",
            { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
            [
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-table-2-item boss-table-2-item-head primary",
                  },
                  [_vm._v("ステータス")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "boss-table-2-item boss-table-2-item-body",
                    class: {
                      "pega-empty-select required":
                        _vm.message.isStatusChange === null,
                    },
                    attrs: { "data-test": "update-status" },
                  },
                  [
                    _c("div", { staticClass: "pega-input no-gray" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.message.isStatusChange,
                            expression: "message.isStatusChange",
                          },
                        ],
                        staticClass: "boss-input-checkbox pega-input-button",
                        attrs: {
                          type: "radio",
                          "data-test": "do-update-status",
                        },
                        domProps: {
                          value: true,
                          checked: _vm._q(_vm.message.isStatusChange, true),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.message, "isStatusChange", true)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              _vm.message.isStatusChange = true
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("送信後")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.message.statusId,
                                  expression: "message.statusId",
                                },
                              ],
                              staticClass: "boss-send-select-template",
                              attrs: {
                                disabled: !_vm.message.isStatusChange,
                                "data-test": "select-update-status",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.message,
                                    "statusId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v("−"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.seminarStatuses, function (status, i) {
                                return _c(
                                  "option",
                                  { key: i, domProps: { value: status.id } },
                                  [
                                    _vm._v(
                                      _vm._s(status.name) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("に更新する")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "pega-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.message.isStatusChange,
                            expression: "message.isStatusChange",
                          },
                        ],
                        staticClass: "boss-input-checkbox",
                        attrs: {
                          type: "radio",
                          "data-test": "do-not-update-status",
                        },
                        domProps: {
                          value: false,
                          checked: _vm._q(_vm.message.isStatusChange, false),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.message,
                              "isStatusChange",
                              false
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: { "data-test": "do-not-update-status-label" },
                        },
                        [_vm._v("更新しない")]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout boss-layout-center" }, [
      _c(
        "button",
        {
          staticClass: "boss-button boss-button-confirm pega-button",
          attrs: { disabled: _vm.hasErrors, "data-test": "confirmation" },
          on: { click: _vm.onConfirmClick },
        },
        [
          _c("span", { staticClass: "boss-button-confirm-text" }, [
            _vm._v("送信内容を確認する"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-scout-send-left" }, [
      _vm._v("\n        件名\n        "),
      _c("small", [_vm._v("（200文字以内）")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-scout-send-left" }, [
      _vm._v("本文"),
      _c("small", [_vm._v("（10000文字以内）")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }